<div class="min-h-screen w-full bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center p-4">
  <div class="max-w-md w-full">
    <div class="bg-white rounded-2xl shadow-2xl overflow-hidden border border-sky-100">
      <!-- Card Header with Logo -->
      <div class="bg-gradient-to-r from-sky-500 to-sky-600 px-6 py-8">
        <div class="flex items-center justify-center">
          <div class="flex items-center space-x-3">
            <!-- Logo placeholder - you can replace with actual logo -->
            <div class="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg">
              <img src="/public/images/simplygenie_logo_w.png" alt="SimplyGenie" class="w-10 h-10 rounded-full">
            </div>
            <h1 class="text-white text-2xl font-bold">SimplyGenie</h1>
          </div>
        </div>
      </div>
      
      <!-- Card Body with Message -->
      <div class="px-6 py-8">
        <div class="text-center">
          <div class="mb-6">
            <!-- Success Icon -->
            <div class="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-12 h-12 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
          </div>
          <h2 class="text-3xl font-bold text-gray-800 mb-4">
            Email Verification
          </h2>
          <p class="text-gray-600 text-lg leading-relaxed mb-6">
            Your email has been successfully verified! You can now access all features of your SimplyGenie account.
          </p>
          
          <!-- Action Buttons -->
          <div class="space-y-3">
            <button 
              class="w-full bg-gradient-to-r from-sky-500 to-sky-600 text-white py-3 px-6 rounded-lg font-semibold hover:from-sky-600 hover:to-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2 transition duration-200 shadow-lg"
              (click)="navigateToDashboard()">
              Continue to Dashboard
            </button>
            <button 
              class="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 transition duration-200"
              (click)="navigateToLogin()">
              Back to Login
            </button>
          </div>
        </div>
      </div>
      
      <!-- Card Footer -->
      <div class="bg-gradient-to-r from-sky-50 to-blue-50 px-6 py-4">
        <div class="text-center">
          <p class="text-sm text-sky-600 font-medium">Thank you for using SimplyGenie</p>
        </div>
      </div>
    </div>
  </div>
</div>